// src/services/catalogService.js
import axios from "axios";
import { buildHeaders } from "./_headers.util";

const API_URL = process.env.VUE_APP_API_URL || "http://127.0.0.1:8000/api/";

class CatalogService {
  permissionsCatalog() {
    return axios.get(`${API_URL}catalogs/permissions`, { headers: buildHeaders() });
  }
}

export default new CatalogService();
